// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21Tju","left":"styles_left__3ZHlf"};